function providerReducer(currentState = [], action){
    switch (action.type) {
        case 'PROVIDER_INIT':
            return action.payload;
        default:
            break;
    }
    return currentState;
}

export default providerReducer;